package com.starparty.app.astro0.renderers

import com.starparty.app.astro0.Circle
import com.starparty.app.astro0.Grid
import com.starparty.app.astro0.SP_Canvas
import com.starparty.app.astro0.SP_Paint

/**
 * Title:
 * Description:
 * Copyright:    Copyright (c) 2002
 * Company:
 * @author
 * @version 1.0
 */
object GridRenderer {
    var ZENITH_LABEL = "Zenith"
    var NADIR_LABEL = "Nadir"
    var N_LABEL = "North"
    var S_LABEL = "South"
    var E_LABEL = "East"
    var W_LABEL = "West"

    fun paintWholeGrid(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint
    ) {
        paintAllLongitudeLines(grid, c, p)
        paintAllLatitudeLines(grid, c, p)
    }

    fun paintAllLongitudeLines(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint
    ) {
        val lonLines = grid.lonLines
        for (lon in lonLines.indices) {
            paintCircle(lonLines[lon], c, p)
        }
    }

    fun paintlongitudeLine(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint,
        lineNo: Int
    ) {
        val lonLines = grid.lonLines
        paintCircle(lonLines[lineNo], c, p)
    }

    fun paintLatitudeLine(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint,
        lineNo: Int
    ) {
        val latLines = grid.latLines
        paintCircle(latLines[lineNo], c, p)
    }

    fun paintAllLatitudeLines(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint
    ) {
        val latLines = grid.latLines
        for (lat in latLines.indices) {
            paintCircle(latLines[lat], c, p)
        }
    }

    // STUBB
    fun paintSolidBackgroundColors(
        grid: Grid?,
        c: SP_Canvas,
        p: SP_Paint
    ) {
    }

    internal fun paintAltLabels(
        grid: Grid,
        c: SP_Canvas,
        p: SP_Paint
    ) {

    }
/*
    fun paintSolidCircle(
        circle: Circle,
        c: SP_Canvas,
        p: SP_Paint
    ) {
        val bounds = c.clipBounds
        val proj = circle.projectedPoints
        val path = SP_Path()
        val end = proj!!.size - 1
        var lastX = round(proj!![end]!!.x).toInt()
        var lastY = round(proj!![end]!!.y).toInt()
        var alreadyIntersecting = false
        var firstEdge = -1
        val secondEdge = -1
        val direction = 0

        // Find edge
        for (i in proj!!.indices) {
            val x = round(proj!![i]!!.x).toInt()
            val y = round(proj!![i]!!.y).toInt()
            val lastIntersects = bounds.contains(lastX.toFloat(), lastY.toFloat())
            val curIntersects = bounds.contains(x.toFloat(), y.toFloat())
            if (lastIntersects != curIntersects) {
                firstEdge = i
                val fromLeft = lastX < x
                break
            }
        }
        for (i in proj!!.indices) {
            val x = round(proj!![i]!!.x).toInt()
            val y = round(proj!![i]!!.y).toInt()
            val intersects = bounds.contains(x.toFloat(), y.toFloat())
            if (intersects && i == 0) {
                path.moveTo(x.toFloat(), y.toFloat())
            }
            if (intersects) {
                if (!alreadyIntersecting) {
                    val fromLeft = lastX < x
                    if (fromLeft) {
                        path.moveTo(bounds.right.toFloat(), bounds.bottom.toFloat())
                        path.lineTo(bounds.left.toFloat(), bounds.bottom.toFloat())
                    } else {
                        path.moveTo(bounds.left.toFloat(), bounds.bottom.toFloat())
                        path.lineTo(bounds.right.toFloat(), bounds.bottom.toFloat())
                    }
                    alreadyIntersecting = true
                    path.lineTo(lastX.toFloat(), lastY.toFloat())
                }
                path.lineTo(x.toFloat(), y.toFloat())
            }
            if (!intersects) {
                if (alreadyIntersecting) {
                    path.lineTo(x.toFloat(), y.toFloat())
                    val fromLeft = lastX < x
                    if (fromLeft) {
                        path.lineTo(bounds.right.toFloat(), bounds.bottom.toFloat())
                    } else {
                        path.lineTo(bounds.left.toFloat(), bounds.bottom.toFloat())
                    }
                }
            }
            lastX = x
            lastY = y
        }

        // c.drawPath(path, p); todo get fill to work properly.
    }
*/
    internal fun paintCircle(
    circle: Circle,
    c: SP_Canvas,
    p: SP_Paint
    ) {
        val proj = circle.projectedPoints
        val end = proj.size - 1
        var lastX = proj[end].x
        var lastY = proj[end].y

        for (i in proj.indices) {
            val x = proj[i].x
            val y = proj[i].y

            c.drawLine(
                    lastX, lastY, x, y,
                        p
                )
            lastX = x
            lastY = y
        }
    }
}